import { Button, ButtonType, Spacing } from 'farmhub-ui-core';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import { CButton } from 'components';
import { saveRoute } from 'slice';
import { theme } from 'styled';

import { Wrapper } from './styles';

interface FooterProps {
  onSubmit?: any;
  src?: any;
  content?: Array<any>;
  rules?: Array<any>;
  isSubmitting?: boolean;
  disabled?: boolean;
  buttons?: Array<{
    onClick: any;
    width: string;
    content: string;
    loading: boolean;
    disabled: boolean;
  }>;
}

const Footer = ({
  onSubmit,
  src,
  content = ['', ''],
  rules = [],
  isSubmitting = false,
  disabled,
  buttons = [],
}: FooterProps): JSX.Element => {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();

  return (
    <Wrapper>
      <Spacing size="middle">
        <Button
          height={theme.button.height.md}
          type={ButtonType.Text}
          weight="bold"
          onClick={() => {
            dispatch(saveRoute(location.pathname));
            history.goBack();
          }}
        >
          {content[0]}
        </Button>
        {buttons.map((button, index) => (
          <CButton
            ghost
            disabled={button.disabled}
            height={theme.button.height.md}
            loading={button.loading}
            type={ButtonType.Primary}
            onClick={button.onClick}
          >
            {button.content}
          </CButton>
        ))}
        <CButton
          disabled={disabled}
          height={theme.button.height.md}
          loading={isSubmitting}
          rules={rules}
          src={src}
          type={ButtonType.Primary}
          onClick={onSubmit}
        >
          {content[1]}
        </CButton>
      </Spacing>
    </Wrapper>
  );
};

export default Footer;
